import styled from 'styled-components'
import { FeaturedCard } from '../components/FeaturedRecipe'
import { FeaturedContentContainer } from '../components/FeaturedContent'
import { breakpoint } from '../layout/styles'
import { Cta } from './Cta'
import Grid from './Grid'

export const ListingHeader = styled.div<any>`
  color: var(--text);
  margin: 0 auto;
  max-width: 1120px;
  h2 {
    font-weight: 700;
    line-height: 1.3;
    font-size: 36px;
    @media ${breakpoint.desktop} {
      font-size: 48px;
    }
  }
  padding: 1.5rem;
  @media ${breakpoint.desktop} {
    padding: 0;
  }
  & > ${Grid} {
    max-width: 1120px;
    @media ${breakpoint.desktop} {
      margin: 92px auto 36px;
    }
  }
  h3 {
    font-size: 28px;
    line-height: 1.1;
    margin: 2rem 0 0;
    @media ${breakpoint.desktop} {
      font-size: 36px;
      margin: 4rem 0 1rem;
    }
  }
 `

export const ListingFeaturedContent = styled.div<any>`
  display: none;
  @media ${breakpoint.desktop} {
    display: block;
  }
  width: 100%;
  &&& {
    ${FeaturedCard} {
      padding-bottom: 0;
      background-color: ${props => props.product ? '#F4F0EE': 'rgba(230, 177, 14, 0.4)'} !important;
      ${Cta} {
        color: black;
      }
      & > div > div:nth-child(1) {
        flex: 3.1;
      }
      & > div > div:nth-child(2) {
        flex: 9.5;
      }
    }
    ${FeaturedContentContainer} {
      padding-bottom: 0;
      flex: 3.25;
      background-color: #F4F0EE;
      h2 {
        margin-top: 0;
      }
      ${Cta} {
        margin-bottom: 1rem;
      }
      p {
        margin-bottom: 1rem;
      }
    }
  }
`

export const ListingWrapper = styled.div`
  color: var(--text);
  display: flex;
  max-width: 1120px;
  margin: 0 auto;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 1.5rem;
  @media ${breakpoint.desktop} {
    padding: 0;
    margin: 36px auto 0;
  }
  &:after {
    content: "";
    flex: 0 0 350px;
  }
`

export default ListingWrapper